import { UA } from './ua';
import { RU } from './ru';
import { PL } from './pl';

export const LANG_TRANSLATION = {
  UA,
  RU,
  PL,
};
